import axios from 'axios';
import { API_BASE_URL, API_TOKEN } from '../config/env';

/**
 * API configuration for Axios
 *
 * This file provides a centralized configuration for all API calls using Axios.
 * The API base URL is read from environment variables, making it configurable
 * across different environments (development, staging, production).
 */

/**
 * Configured Axios instance with common settings
 */
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 seconds timeout
});

// Request interceptor for API calls
apiClient.interceptors.request.use(
  (config) => {
    // Add API token to all requests
    if (API_TOKEN) {
      config.headers['X-API-Token'] = API_TOKEN;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for API calls
apiClient.interceptors.response.use(
  (response) => {
    // You can add common response handling here
    return response;
  },
  (error) => {
    // Handle common error scenarios
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default apiClient;

// Export common API endpoints as constants
export const API_ENDPOINTS = {
  LIVENESS: {
    SESSION: '/identity-verification/liveness',
    SESSION_BY_ID: (sessionId: string | undefined, livenessSessionToken?: string) => {
      if (!sessionId) {
        return '/identity-verification/liveness';
      }

      const token = livenessSessionToken?.trim();
      if (!token) {
        return `/identity-verification/liveness/${sessionId}/status`;
      }

      return `/identity-verification/liveness/${sessionId}/status?token=${encodeURIComponent(token)}`;
    },
    WEBHOOK: (livenessSessionToken?: string) => {
      const token = livenessSessionToken?.trim();
      if (!token) {
        return '/identity-verification/liveness/webhook';
      }

      return `/identity-verification/liveness/webhook?token=${encodeURIComponent(token)}`;
    },
  },
  DOCUMENT: {
    UPLOAD: '/api/document/upload',
    GET_BY_SESSION: (sessionId: string | undefined) =>
      sessionId ? `/api/document/${sessionId}` : '/api/document',
  },
};
